function applyThemeFromLocalStorage() {
  // Retrieve the theme from localStorage
  var ldTheme = localStorage.getItem('ldSwitch');
  var selectedIcon = 1; // Default to dark mode icon (moon)
  var themeToApply = 'dark'; // Default theme

  // If no theme is stored, set to dark mode by default
  if (!ldTheme) {
    ldTheme = 'dark';
    selectedIcon = 1; // Moon icon for dark mode
    themeToApply = 'dark';
    localStorage.setItem('ldSwitch', ldTheme);
    localStorage.setItem('ldSwitchIcon', selectedIcon);
  } else {
    // Map stored theme name to option index and icon
    if (ldTheme === 'dark') {
      selectedIcon = 1; // Dark mode corresponds to data-value="1"
      themeToApply = 'dark';
    } else if (ldTheme === 'light') {
      selectedIcon = 0; // Light mode corresponds to data-value="0"
      themeToApply = 'light';
    }
  }

  // Apply the theme to the HTML element
  document.documentElement.setAttribute('data-theme', themeToApply);

  // Update the switcher icon
  var switcher = document.querySelector('.js-ld-switch');
  if (switcher) {
    var button = switcher.querySelector('.js-ld-switch-toggle');
    var label = switcher.querySelector('.js-ld-switch-label');
    var icons = switcher.getElementsByClassName('js-ld-switch-icon');

    if (icons.length > selectedIcon) {
      for (var i = 0; i < icons.length; i++) {
        icons[i].classList.remove('ld-switch-btn__icon-wrapper--in');
      }
      icons[selectedIcon].classList.add('ld-switch-btn__icon-wrapper--in');
    }

    if (button) {
      button.setAttribute('aria-pressed', selectedIcon === 1 ? 'true' : 'false');
    }

    if (label) {
      label.textContent = 'Toggle color theme (currently ' + themeToApply + ')';
    }
  }
}

applyThemeFromLocalStorage();

import { initLightDarkSwitchEx } from './components/_3_light-dark-switch.js';

document.addEventListener('DOMContentLoaded', function () {
  initLightDarkSwitchEx();
});




function alignRows() {
	const labels = document.querySelectorAll('.labels .row');
	const pressable = document.querySelectorAll('.pressable .row');
	const wpengine = document.querySelectorAll('.wpengine .row');
	const isDesktop = window.innerWidth >= 768; // Check if the screen is desktop size

	// Reset all row heights to 'auto' for a fresh calculation
	pressable.forEach(row => row.style.height = 'auto');
	wpengine.forEach(row => row.style.height = 'auto');
	labels.forEach(row => row.style.height = 'auto');

	const rowCount = Math.max(labels.length, pressable.length, wpengine.length);

	for (let i = 0; i < rowCount; i++) {
		const labelRow = labels[i];
		const pressableRow = pressable[i];
		const wpengineRow = wpengine[i];

		if (isDesktop) {
			// On desktop, include the labels column in the height calculation
			const maxHeight = Math.max(
				labelRow ? labelRow.offsetHeight : 0,
				pressableRow ? pressableRow.offsetHeight : 0,
				wpengineRow ? wpengineRow.offsetHeight : 0
			);

			// Set all rows to the maximum height
			if (labelRow) labelRow.style.height = maxHeight + 'px';
			if (pressableRow) pressableRow.style.height = maxHeight + 'px';
			if (wpengineRow) wpengineRow.style.height = maxHeight + 'px';

		} else {
			// On mobile, ignore the labels column and only check the other two
			const maxHeight = Math.max(
				pressableRow ? pressableRow.offsetHeight : 0,
				wpengineRow ? wpengineRow.offsetHeight : 0
			);

			// Set only the pressable and wpengine rows to the maximum height
			if (pressableRow) pressableRow.style.height = maxHeight + 'px';
			if (wpengineRow) wpengineRow.style.height = maxHeight + 'px';
		}
	}
}

// Call alignRows on load and when resizing the window
window.addEventListener('load', alignRows);
window.addEventListener('resize', alignRows);